<template>
    <div class="main-content">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>试卷统计</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" size="small" :model="formInline" class="user-search">
            <el-form-item label="科目类别：">
                <el-select clearable v-model="formInline.courseCategoryId">
                    <el-option v-for="item in courseList" :key="item.courseCode" :label="item.courseCategoryName"
                        :value="item.courseCategoryId"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="试卷名称：">
                <el-input size="small" v-model="formInline.examNameLike" placeholder="请输入试卷名称"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" @click="search()">搜索</el-button>
            </el-form-item>
        </el-form>
        <div class="main-table">
            <my-table :columns="tableForm.customColumns" :tableData="tableForm.tableData" :loading="tableForm.isLoading">
                <el-table-column align="center" prop="userSex" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" v-buttonAuth="'system:statistics:records'"
                            @click="goRecords(scope.row)">考试记录</el-button>
                    </template>
                </el-table-column>
            </my-table>
        </div>
        <div class="main-pagination">
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </div>
    </div>
</template>

<script>
import MyTable from '@/components/myTable.vue';
import Pagination from '@/components/Pagination'
import myForm from '@/components/myForm.vue';
import store from '../../vuex/store';
import { capitalEnglishList, fileDownload, organizationName } from "@/utils/util.js";
import courseApi from '@/api/onlineTraining/classification.js'
import PreviewPapers from '../../components/previewPapers.vue';
import { examStatPage } from '@/api/exam.js'

export default {
    components: {
        MyTable,
        Pagination,
        myForm,
        PreviewPapers,
    },
    data () {
        return {
            courseList: [],

            formInline: {
                courseCategoryId: '',
                examNameLike: ''
            },
            tableForm: {
                customColumns: [
                    { label: '所属机构', prop: 'name', formatter: () => { return organizationName } },
                    { label: '科目类别', prop: 'courseCategoryName' },
                    { label: '试卷名称', prop: 'examName' },
                    { label: '命题方式', prop: 'selectQuestionTypeText'},
                    { label: '试卷总分', prop: 'totalScore' },
                    { label: '题目总数', prop: 'questionNum' },
                    { label: '及格分数', prop: 'passScore' },
                    { label: '及格题目数', prop: 'passNum' },
                    { label: '参与人数', prop: 'joinPeopleCount' },
                    { label: '通过人数', prop: 'passPeopleCount' },
                    { label: '通过率', prop: 'passRateDesc' },
                ],
                tableData: [
                ],
                isLoading: false,
            },
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            previewDialog: {
                isPreview: false,
                examId: '',
                visible: false
            },

        }
    },
    created () {
        console.log(this.$route.query)
        this.getDictionary();
        this.getData()
    },
    methods: {
        async getDictionary () {
            const courseRes = (await courseApi.courseCategoryList({ pageNum: 1, pageSize: 999999, stateSign: true })).data;
            this.courseList = courseRes;
        },
        search () {
            this.pageparm.currentPage = 1;
            this.getData();
        },
        async getData () {
            const params = {
                pageNum: this.pageparm.currentPage,
                pageSize: this.pageparm.pageSize,
                ...this.formInline,
            }
            const res = await examStatPage(params);
            this.tableForm.tableData = res.data.records;
            this.pageparm.total = res.data.total;
        },
        callFather (parm) {
            this.pageparm.currentPage = parm.currentPage
            this.pageparm.pageSize = parm.pageSize
            this.getData()
        },
        goRecords (item) {
            this.$router.push({ path: '/training/examinationRecord', query: { examPaperId: item.examPaperId,examNameLike:item.examName } });
        },
    }

}
</script>

<style lang="scss" scoped>
.user-search {
    margin-top: 20px;
}

.option-from {
    font-size: 14px;
    margin-bottom: 10px;
    color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/views/training/statistics.vue